import { Injectable, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ErrorInterceptor } from "../providers/http/ErrorInterceptor";

declare let $: any;

export class TableOptions {

  id: number;
  tableClass: string;
  filterText: string;
  scrollPosition: ScrollPosition;
  selectRow: boolean;
  private styledCheckBox: boolean;
  multiSelect: boolean;
  emptySelected: boolean;
  showFooter: boolean;
  loadingData: LoadingData;
  errorData: ErrorData;

  columns: Array<RowFields>;
  data: any[];
  emptyData: any;

  selectedRows: Array<any>;
  rowId: string;
  dataSource: LDataSource;

  clearRowSelected: () => void;
  clearTable: (data: any) => void;
  onBeforeLoadData: () => void;

  visibleRows: number;

  //watchFilterText: (newValue: string, oldValue?: string) => void;

  watchEmptySelected: (newValue: boolean, oldValue?: boolean) => void;

  orderBy: (orderBy: string, orderType: string) => void;
  /**
   * este atributo es para enviar datos adicionales
   * no utilizados por la directiva
   */
  additionalData: any;
  constructor() {
    this.id = new Date().getTime();
    this.tableClass = "no-select no-margin table table-hover table-condensed";
    this.filterText = "";
    this.scrollPosition = new ScrollPosition();

    this.selectRow = true;
    this.multiSelect = false;
    this.styledCheckBox = true;
    this.emptySelected = false;
    this.showFooter = false;
    this.loadingData = new LoadingData();
    this.errorData = new ErrorData();
    this.columns = new Array<RowFields>();
    this.data = new Array<any>();
    this.emptyData = { content: '' };
    this.selectedRows = new Array<any>();
  }

  //  set setFilterText(filterText:string) {
  //    if (this.watchFilterText != null) {
  //      this.watchFilterText(filterText, this.filterText);
  //    }
  //    this.filterText = filterText;
  //  }

  //  get getFilterText(): string {
  //    return this.filterText;
  //  }


  set setEmptySelected(emptySelected: boolean) {
    if (this.watchEmptySelected != null) {
      this.watchEmptySelected(emptySelected, this.emptySelected);
    }
    this.emptySelected = emptySelected;
  }

  get getEmptySelected(): boolean {
    return this.emptySelected;
  }
}

export class RowFields {

  dataIndex: string;
  displayName: string;
  renderer: (value: string, obj: any, index: number) => void;

  constructor(dataIndex: string, displayName: string, renderer?: (value: any, obj: any, index: number) => void) {
    this.dataIndex = dataIndex;
    this.displayName = displayName;
    this.renderer = renderer;
  }
}

export class LoadingData {

  loadingText: string;
  status: boolean;
  height: number;

  constructor() {
    this.loadingText = "<p class='text-center'><i class='fa fa-spinner fa-spin fa-2x text-muted'>" +
      "</i><p><p class='text-center lead text-primary'>Obteniendo Datos...</p>";
    this.status = false;
    this.height = 0;
  }
}

export class ErrorData {

  content: any;
  status: boolean;
  height: number;

  constructor() {
    this.status = false;
    this.height = 0;
  }
}

export class ScrollPosition {

  id: string;
  value: number;
  max: number;
  isMobile: boolean;

  /*  watchValue: (newValue: number, oldValue: number) => void;
  */
  constructor() {
    this.id = "";
    this.value = 0;
    this.max = 0;
    this.isMobile = true;
  }
}

@Injectable()
export class LDataSource implements OnInit {

  url: string;
  method: string;
  root: string;
  data: any;

  private callbackOnBeforeLoad: any;
  private callbackOnLoad: any;
  private callbackOnError: any;

  constructor(private http: HttpClient, private errorInterceptor: ErrorInterceptor) {
    this.url = null;
    this.method = null;
    this.root = null;
    this.data = null;
    this.callbackOnBeforeLoad = $.Callbacks();;
    this.callbackOnLoad = $.Callbacks();;
    this.callbackOnError = $.Callbacks();;
  }


  /**
   * metodo para realizar la peticion GEO O PUT
   */
  private invokeService(parameters: any, callbackDone, callbackFail) {

    if (this.method == "get" || this.method == "GET") {
      this.http.get(this.url, parameters)
        .subscribe(callbackDone, (error) => {
          return callbackFail(this.errorInterceptor.handleError(error));
        });

    } else if (this.method == "put" || this.method == "PUT") {
      this.http.put(this.url, parameters)
        .subscribe(callbackDone, (error) => {
          return callbackFail(this.errorInterceptor.handleError(error));
        });
    }
  }

  load(parameters?: any) {
    if (this.callbackOnBeforeLoad.fire().fired()) {

      this.invokeService(parameters, (response) => {

        this.data = response;
        if (this.root && this.data && this.data.hasOwnProperty(this.root)) {
        }
        this.callbackOnLoad.fire(this.data[this.root], this.data);

      }, (_jqXHR) => {
        let errorObject = null;
        try {
          errorObject = $.parseJSON(_jqXHR.responseText);
        } catch (e) { }

        let simpleErrorMessage = "";
        if (errorObject) {
          simpleErrorMessage = errorObject.errorMessage + " [" + errorObject.errorCode + "]";
        } else {
          simpleErrorMessage = "Http Code: " + _jqXHR.status + ", Http Error: " + _jqXHR.statusText;
        }

        this.callbackOnError.fire(errorObject, _jqXHR, simpleErrorMessage);
      })
    }
  }

  tryAgain() {

    if (this.callbackOnBeforeLoad.fire().fired()) {
      this.invokeService(
        null,
        // ok
        (response) => {
          this.data = response.data;
          if (this.root && this.data && this.data.hasOwnProperty(this.root)) {
            this.data = this.data[this.root];
          }
          this.callbackOnLoad.fire(this.data, response.data);
        },
        // failure
        (_jqXHR) => {

          let errorObject = null;
          try {
            errorObject = $.parseJSON(_jqXHR.responseText);
          } catch (e) { }

          let simpleErrorMessage = "";
          if (errorObject) {
            simpleErrorMessage = errorObject.errorMessage + " [" + errorObject.errorCode + "]";
          } else {
            simpleErrorMessage = "Http Code: " + _jqXHR.status + ", Http Error: " + _jqXHR.statusText;
          }

          this.callbackOnError.fire(errorObject, _jqXHR, simpleErrorMessage);
        }
      );
    }

  }

  onBeforeLoad(_callback) {
    this.callbackOnBeforeLoad.add(_callback);
  }

  onLoad(_callback) {
    this.callbackOnLoad.add(_callback);
  }

  onError(_callback) {
    this.callbackOnError.add(_callback);
  }

  ngOnInit() {

  }
}